import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import _ from 'lodash'

import { convertCaseList, ConvertType } from '@/shared/utils/convertString'

import { IInstituteCurriculumItem, IInstituteCurriculumItemResponse } from '../types'

export const fetchInstituteCurriculumItem = async (
  instituteCode: string,
  curriculumId: string,
  userId: number,
) => {
  const res = await axios.get<IInstituteCurriculumItemResponse>(
    `${window.apiEndpoint}/my/course/v1/institute/${instituteCode}/curriculum/${curriculumId}`,
    {
      headers: {
        sub: userId,
      },
    },
  )

  return convertCaseList(res.data, ConvertType.CAMEL) as IInstituteCurriculumItem
}

export const useInstituteCurriculumItemQuery = (
  instituteCode: string,
  curriculumId: string,
  userId: number,
) => {
  return useQuery({
    queryKey: ['institute-curriculum-item', instituteCode, curriculumId],
    queryFn: () => fetchInstituteCurriculumItem(instituteCode, curriculumId, userId),
    enabled: !!instituteCode && !!curriculumId && !!userId,
    retry: false,
  })
}
